// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__RoqV_","isRelative":"Loader_isRelative__kgcpF","invert":"Loader_invert__rTSl0"};